<template>
  <div class="video">
    <div class="swiper-position">
      <div class="swiper-container swiper-container-landscape">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperData" :key="index">
            <video :src="item.url" controls :id="'videoH' + index" class="video" loop></video>
          </div>
        </div>
        <!-- Add Pagination -->
        <!-- <div class="swiper-pagination"></div> -->
        <!-- Add Arrows -->
        <div class="swiper-button-next swiper-button-next1"></div>
        <div class="swiper-button-prev swiper-button-prev1"></div>
      </div>
    </div>
    <transition name="classicCase">
      <div class="classicCase" v-if="caseShow && listData.length > 0" @click="jumpToPdm($event)">
        <h6>PDM经典案例</h6>
        <vue-seamless-scroll :class-option="classOption" class="seamless-warp" :data="listData" ref="seamlessScroll">
          <ul v-if="listData.length > 0">
            <li class="listItem" v-for="(item, index) in listData" :key="index" :data-obj="JSON.stringify(item)">
              {{ item.title }}
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </transition>
  </div>
</template>

<script>
import "swiper/dist/js/swiper";
import Swiper from "swiper";
export default {
  name: "videoControl",
  props: ["swiperData", "caseShow", "scrollData"],
  components: {},
  data() {
    return {
      listData: [],
      swiper: null,
      seamData: [15],
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 0, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  watch: {
    swiperData: {
      handler(val) {
        if (this.swiperData.length > 0) {
          this.newSwiper();
        }
      },
      deep: true,
      immadiate: true,
    },
  },
  created() {
    if (this.scrollData && this.scrollData.extendDesc.includes(",")) {
      let listData = this.scrollData.extendDesc.split(",").filter(item => item)
      this.listData = listData.map((item, index) => {
        return { title: `${this.scrollData.name}案例 ${index + 1}`, id: item };
      });
    }
  },
  methods: {
    jumpToPdm(item) {
      window.open(`http://www.lhtianan.com.cn:9898/pdm/#/index?productId=${JSON.parse(item.target.dataset.obj).id}`)
    },
    stopLinkSwiper() {
      this.linkSwiper.autoplay.stop();
    },
    startLinkSwiper() {
      this.linkSwiper.autoplay.start();
    },
    stopScroll() {
      this.$refs.marquee.stop();
    },
    startScroll() {
      this.$refs.marquee.start();
    },
    newSwiper() {
      let _this = this;
      this.swiper = new Swiper(".swiper-container-landscape", {
        spaceBetween: 30,
        centeredSlides: true,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next1",
          prevEl: ".swiper-button-prev1",
        },
        on: {
          slideChange: function () {
            console.log(_this.swiper.activeIndex)
            let currentIndex = _this.swiper.activeIndex;
            for (let i in _this.swiperData) {
              if (_this.swiperData[i].type.includes("VIDEO")) {
                let video = document.getElementById(`videoH${i}`);
                video.pause();
              }
            }
            if (_this.swiperData[currentIndex].type.includes("VIDEO")) {
              let currentVideo = document.getElementById(
                `videoH${currentIndex}`
              );
              currentVideo.play();
            }
          },
        },
      });
    },
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.video {
  border-bottom: 7px solid #f5f5f6;
  padding-top: 20px;
  position: relative;

  .swiper-position {
    width: 740px;
    height: auto;
    background: #fff;
    margin: 0 auto;

    .swiper-container {
      width: 100%;
      height: 100%;

      .swiper-wrapper {
        width: 100%;
        height: 100%;

        .swiper-slide {
          height: 100%;
          video {
            width: 100%;
            height: 443px;
          }
        }
      }
    }
  }

  .classicCase {
    width: 250px;
    // height: 150px;
    max-height: 300px;
    background: rgb(242, 242, 242);
    position: absolute;
    top: 50%;
    right: 0px;
    z-index: 9999;
    transform: translateY(-50%);
    border-radius: 10px;
    // box-shadow: 0px 0 15px #000;
    transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
    overflow: hidden;

    h6 {
      padding: 3px 0;
      font-size: 14px;
    }

    .seamless-warp {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 10px;

      .listItem {
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #000;
        font-size: 12px;
        border-bottom: 1px solid #f5f5f6;
        cursor: pointer;
      }

      .listItem:hover {
        color: rgb(0, 102, 204);
        font-weight: bold;
        transform: scale(1.2);
        background: rgb(245, 245, 247);
      }
    }
  }

  .classicCase-enter-active,
  .classicCase-leave-active {
    transition: all 1.5s ease;
  }

  .classicCase-enter,
  .classicCase-leave-to {
    width: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/videoControl.vue